<template>
  <div class="container">
    <div class="">
      <div class="menuContainer">
        <button @click="currentGameType='UPCOMING'; shakeThemes()" :class="{'active': currentGameType === 'UPCOMING'}" class="menuA col position-relative">Доступные лиги мероприятий
        </button>
      </div>
      <div>
        <TransitionGroup name="cardsAnimation">
          <stream-card
            v-for="stream in streams"
            :key="stream.id"
            :stream="stream"
          />
        </TransitionGroup>
        <div v-show="streams.length < 1 && !loading">
          <h3 class="text-center">Пока ничего... </h3>
        </div>
      </div>
      <pre-loader v-if="loading"/>
    </div>
    <div class="moreButton-container">
      <MyButton
          class="more-button"
          v-if="showMoreGameCards && !requestLock"
          @click="loadElseEventCards(nextGameCardsUrlPage)"
          :cls="moreButtonCls"
      >Еще</MyButton>
    </div>
    <div class="gamesContainer"></div>
    <scroll-up></scroll-up>
    <auth-modal ref="auth"></auth-modal>
  </div>
</template>

<script>
import StreamCard from '../components/main/StreamCard.vue';
import ScrollUp from '../components/UI/ScrollUp.vue';
import MyButton from "../components/UI/MyButton";
import {mapActions, mapState} from "vuex";
import AuthModal from '../components/AuthModal.vue'
export default {
  components: {
    ScrollUp,
    AuthModal,
    MyButton,
    StreamCard
  },
  name: "GameStreams",
  data() {
    return {
      showMoreGameCards: false,
      nextGameCardsUrlPage: 1,
      showMenu: false,
      themes: [],
      currentThemes: [],
      currentEvents: [],
      nextEvents: [],
      pastEvents:[],
      developmentThemes: [],
      myEvents: [],
      currentGameType: 'UPCOMING',
      moreButtonCls: 'pink',
      requestLock: false,
      loading: true,
      streams: [],
    }
  },
  mounted() {
    this.currentGameType = this.$route.query.type || 'UPCOMING'
    this.shakeThemes()
  },
  computed: {
    ...mapState(['isAuthenticated'])
  },
  watch: {
    currentGameType(val) {
      this.$router.push({name: 'Games', query: {type: val}})
      this.shakeThemes()
    },

  },
  methods: {
    ...mapActions(['GET_USER_DETAILS']),
    setLike(themeId, status) {
      let themes = this.currentThemes.map(theme => theme.id === themeId ? Object.assign({}, theme, {isLiked:status}) : theme)
      this.GET_USER_DETAILS().then(()=>this.processThemes(themes))
    },
    showAuthModal() {
      this.$refs.auth.showAuthModal();
    },
    processStreams(streams) {
      this.streams = streams
    },
    isStreamInUrl(url) {
      return url.includes('/stream/');
    },
    shakeThemes(){
      console.log('SHAKE')
      this.loading = true
      if (!this.requestLock) {
        this.requestLock = true
        this.showMenu = false
        this.currentThemes = []
        this.currentEvents = []
        this.showMoreGameCards = false
        let loadStreams = this.$api.getAvailableStreamList()
        if (loadStreams){
          loadStreams.then(data=>{
            let streams = []
            streams = data
            this.processStreams(streams)
          })
          .finally(()=>{
              this.loading = false
              this.requestLock = false
            })
        }
      }
    },
    loadElseEventCards(page) {
      this.loading = true
      if (this.currentGameType == 'UPCOMING') {
        null
      } else if (this.currentGameType == 'RECENT') {
        this.requestLock = true
        this.loadRecent(page)
      } else if (this.currentGameType == 'MYGAMES') {
        null
      } else if (this.currentGameType == 'FAVOURITES') {
        null
      } else if (this.currentGameType == 'DEVELOPMENT') {
        null
      }
    },
    loadRecent(page){
      const vm = this
      return vm.$api.getPastGames(page)
       .then(data=>{
        if (data.next != null) {
          vm.showMoreGameCards = true
          vm.nextGameCardsUrlPage = data.next.split('page=')[1]
        } else {
          vm.showMoreGameCards = false
        }
        vm.moreButtonCls = 'pink'
        vm.processEvents(data.results, true)

      })
      .finally(()=>vm.loading=false)
    }
  },
}
</script>

<style scoped>
.menuContainer {
  display: flex;
  align-items: center;
  /*padding-top: 1.5rem;*/
  padding-bottom: 1.5rem;
  overflow-x: auto;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.gamesContainer {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 5%;
  margin-top: 5%;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
}
.h2Log {
  cursor: pointer;
}
button {
  text-align: left;
}
.menuA {
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.6);
  padding-bottom: 0.5rem;
  padding-right: 1rem;
  padding-left: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  white-space: nowrap;
  text-align: center;
}
.menuDD {
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.6);
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;
  width: 100%;
}
.menuA:hover,
.menuDD:hover,
.active {
  border-bottom: 1px solid #E32289;
  color: rgba(255, 255, 255, 1);
}
.cardsAnimation-enter-active,
.cardsAnimation-leave-active {
  transition: all 0.5s ease;
}
.cardsAnimation-enter-from,
.cardsAnimation-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.seperator {
  width: 80%;
  border-bottom: 1px solid white;
  opacity: 0.1;
  margin-top: 1rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
}
.moreButton-container {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}
@media (min-width: 1200px) {
  /* CSS для: ширины >= 1200px */
  button {
    text-align: center;
  }
}
</style>
